import * as zod from 'zod';

export default zod.object({
  completedCount: zod.number().int().nonnegative(),
  currentActivity: zod.enum([
    'none',
    'requestingPlan',
    'planning',
    'receivingPlan',
    'moving',
    'paused',
  ]),
  /**
   * Tracks which stop early condition group was met.
   * 0 = not stopped early
   * 1+ = index of the OR group that caused early stop (1-indexed)
   */
  stoppedEarly: zod.number().int().nonnegative().default(0),
});
